import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgencyHierarchyManagementComponent } from './agency-hierarchy-management.component';
import { DxSplitterModule, DxTreeListModule } from 'devextreme-angular';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { AgencyHierarchyManagementService } from './agency-hierarchy-management.service';

@NgModule({
  imports: [CommonModule, SharedModule, DxTreeListModule, DxSplitterModule],
  declarations: [AgencyHierarchyManagementComponent],
  exports: [AgencyHierarchyManagementComponent],
  providers: [AgencyHierarchyManagementService],
})
export class AgencyHierarchyManagementModule {}
